import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/public/icons/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/public/icons/mail.svg");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/public/icons/phone.svg");
;
import(/* webpackMode: "eager" */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/public/icons/time.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deployer/www/black-friday-norge.no/releases/20261023_105100/src/components/ui/ExternalLink/index.tsx");
